// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 2H20V11H22V22H2V11H4V2ZM18 11V4H6V11H18ZM8 6.49609H10.0039V8.5H8V6.49609ZM14 6.49609H16.0039V8.5H14V6.49609Z"}}]};

const UsbFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'usb-filled',
    ref,
    icon: element,
  },
));

UsbFilledIcon.displayName = 'UsbFilledIcon';

export default UsbFilledIcon;
